import React from 'react';

import Input from '../../../components/Input';

function MultiNumericFilter({filter, onChange, validations}) {
  return (
    <Input
      placeholder="Value"
      type="number"
      step="any"
      value={filter.values[0] || ''}
      onChange={e => onChange({...filter, values: [e.target.value]})}
      invalid={validations.length > 0}
      validationText={validations[0]}
    />
  );
}

MultiNumericFilter.validate = filter => {
  const messages = [];

  if (!isNumber(filter.values[0])) {
    messages.push('Enter a valid number');
  }

  return messages;
};

MultiNumericFilter.operators = [
  'CONTAIN'
];

function isNumber(str) {
  if (str === '' || str === null) {
    return false;
  }

  return !isNaN(Number(str));
}

export default MultiNumericFilter;